import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoIntValidator,
  passportValidator,
  requiredValidator,
} from "./../../components/formFields/CommonValidator";
import { useAppDispatch, useAppSelector } from "./../../app/hooks";
import {
  createVisaQuotation,
  getVisaQuotationByID,
  updateVisaQuotation,
} from "./services/quotation.services";
import {
  clearVisaQuotationInformation,
  setQuotationType,
} from "./quotationSlice";
import ShadowCard from "./../../components/common/ShadowCard";
import moment from "moment";
import { getVisaInquiryByID } from "./../inquiry/services/inquiry.services";
import {
  getContactByID,
  insertContactFromOtherPlace,
} from "./../contact/services/contact.services";
import FormSelectionField from "./../../components/formFields/FormSelectionField";
import { clearInquiryDetails } from "./../inquiry/inquirySlice";
import { LoadingPanel } from "./../../components/layout/Loading";
import { getLeadByID } from "./../lead/services/lead.services";
import { clearLeadDetails } from "./../lead/leadSlice";
import { clearContactDetails } from "./../contact/contactSlice";
import FormTextField from "../../components/formFields/FormTextField";
import FormDatePicker from "../../components/formFields/FormDateField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import RippleButton from "../../components/common/RippleButton";
import { getAllActiveNationalities } from "../nationality/services/nationality.services";
import { INationality } from "../nationality/nationalityModel";
import { MARITALSTATUS, NAMEPREFIX } from "../../_contstants/common";
import FormTextArea from "../../components/formFields/FormTextArea";
import CardRadioGroup from "../../components/formFields/CardRadioGroup";
import {
  getAllActiveVisaCountries,
  getVisaCountryWiseDocumentData,
} from "../visacountry/services/visacountry.services";
import {
  getAllActiveVisaCategories,
  // getVisaCategoryWiseDocumentData,
} from "../visacategory/services/visa.services";
import { IVisaCountry } from "../visacountry/visacountryModel";
import { IVisaCategory } from "../visacategory/visaCategoryModel";
import { IVisaProcessingOption } from "../visaprocessingoption/visaprocessingoptionModel";
import { getAllActiveVisaProcessingOptions } from "../visaprocessingoption/services/visaprocessingoption.services";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { getAllActiveTravelPurposes } from "../travelpurpose/services/travelpurpose.services";
import { ITravelPurpose } from "../travelpurpose/travelpurposeModel";
import { getAllActiveEmploymentStatus } from "../employmentstatus/services/employmentstatus.services";
import { IEmploymentStatus } from "../employmentstatus/employmentstatusModel";
import { getAllActiveSponsorshipType } from "../sponsorshiptype/services/sponsorshiptype.services";
import { ISponsorshipType } from "../sponsorshiptype/sponsorshiptypeModel";
import CardCheckboxGroup from "../../components/formFields/CardCheckboxGroup";
import { getAllActiveAdditionalServices } from "../additionalservice/services/additionalservice.services";
import { IAdditionalService } from "../additionalservice/additionalserviceModel";
import { getAllActiveDocument } from "../document/services/document.services";
import { getAdminSettings } from "../adminsetting/services/adminsetting.services";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import { ICompany } from "../company/companyModel";
import { getAllActiveCompanies } from "../company/services/company.services";
import { getAllActiveEntryTypes } from "../visaentrytype/services/visaentrytype.services";
import { IEntryType } from "../visaentrytype/visaentrytypeModel";
import { ErrorToast } from "../../components/toast/Toasts";

// export const countryOptions = [
//   {
//     value: "US",
//     label: "United States",
//     code: "US",
//     visaTypes: 3,
//   },
//   {
//     value: "GB",
//     label: "United Kingdom",
//     code: "GB",
//     visaTypes: 3,
//   },
//   {
//     value: "CA",
//     label: "Canada",
//     code: "CA",
//     visaTypes: 3,
//   },
//   {
//     value: "AU",
//     label: "Australia",
//     code: "AU",
//     visaTypes: 3,
//   },
//   {
//     value: "EU",
//     label: "Schengen Area",
//     code: "EU",
//     visaTypes: 2,
//   },
//   {
//     value: "AE",
//     label: "UAE (Dubai)",
//     code: "AE",
//     visaTypes: 2,
//   },
//   {
//     value: "SG",
//     label: "Singapore",
//     code: "SG",
//     visaTypes: 1,
//   },
//   {
//     value: "JP",
//     label: "Japan",
//     code: "JP",
//     visaTypes: 2,
//   },
// ];

// // 2. Visa Type Data
// export const visaOptions = [
//   {
//     value: "visitor",
//     label: "Visitor Visa",
//     visaCode: "600",
//     processing: "2-4 weeks",
//     price: 10000,
//   },
//   {
//     value: "student",
//     label: "Student Visa",
//     visaCode: "500",
//     processing: "4-6 weeks",
//     price: 25000,
//   },
//   {
//     value: "skilled",
//     label: "Skilled Independent",
//     visaCode: "189",
//     processing: "6-8 months",
//     price: 40000,
//   },
// ];

// // 3. Processing Type Data
// export const processingOptions = [
//   {
//     value: "standard",
//     label: "Standard Processing",
//     description: "Regular processing time with standard documentation review",
//     price: 2500,
//     badge: "7-10 days",
//   },
//   {
//     value: "express",
//     label: "Express Processing",
//     description: "Faster processing with priority handling",
//     price: 4500,
//     badge: "3-5 days",
//   },
//   {
//     value: "urgent",
//     label: "Urgent Processing",
//     description: "Emergency processing for urgent travel",
//     price: 7500,
//     badge: "1-2 days",
//   },
// ];

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const VisaCountryChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();

  const VisaCountryID = formRenderProps.valueGetter("VisaCountryID") || null;

  useEffect(() => {
    if (VisaCountryID) {
      dispatch(getVisaCountryWiseDocumentData(VisaCountryID));
    }
  }, [VisaCountryID]);

  return null;
};

const CreateVisaQuotation: React.FC = () => {
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const VisaQuotationID = location.state?.VisaQuotationID;
  const InquiryID = location.state?.InquiryID;

  const loading = useAppSelector((state) => state.quotation.loading);
  const contactLoading = useAppSelector((state) => state.contact.formLoading);
  const VisaQuotationDetail = useAppSelector(
    (state) => state.quotation.VisaQuotationDetail,
  );
  // const InquiryDetails = useAppSelector(
  //   (state) => state.inquiry.InquiryDetails
  // );

  const InquiryVisaDetails = useAppSelector(
    (state) => state.inquiry.InquiryVisaDetails,
  );

  // const LeadSourceList = useAppSelector(
  //   (state) => state.leadsource.LeadSourceList
  // );
  // const SectorList = useAppSelector((state) => state.sector.SectorList);
  // const CompanyList = useAppSelector((state) => state.company.CompanyList);
  const VisaCountryList = useAppSelector(
    (state) => state.visacountry.VisaCountryList,
  );
  const VisaCategoryList = useAppSelector(
    (state) => state.visacategory.VisaCategoryList,
  );
  const VisaProcessingOptionList = useAppSelector(
    (state) => state.visaprocessingOption.VisaProcessingOptionList,
  );
  const TravelPurposeList = useAppSelector(
    (state) => state.travelpurpose.TravelPurposeList,
  );
  const EmploymentStatusList = useAppSelector(
    (state) => state.employmentstatus.EmploymentStatusList,
  );
  const SponsorshipTypeList = useAppSelector(
    (state) => state.sponsorshiptype.SponsorshipTypeList,
  );
  const AdditionalServiceList = useAppSelector(
    (state) => state.additionalservice.AdditionalServiceList,
  );
  const VisaDocumentList = useAppSelector(
    (state) => state.visacountry.VisaDocumentList,
  );

  const LeadDetails = useAppSelector((state) => state.lead.LeadDetails);
  const leadLoading = useAppSelector((state) => state.lead.formLoading);
  const ContactDetails = useAppSelector(
    (state) => state.contact.ContactDetails,
  );
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails,
  );

  const NationalityList = useAppSelector(
    (state) => state.nationality.NationalityList,
  );

  const CompanyList = useAppSelector((state) => state.company.CompanyList);
  const EntryTypeList = useAppSelector(
    (state) => state.visaentrytype.EntryTypeList,
  );

  // const RoomCategoryList = useAppSelector(
  //   (state) => state.roomCategory.RoomCategoryList
  // );

  // const MealTypeList = useAppSelector((state) => state.mealType.MealTypeList);

  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>(VisaQuotationDetail);

  useEffect(() => {
    if (InquiryVisaDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: InquiryVisaDetails?.Initial,
        FirstName: InquiryVisaDetails?.FirstName,
        LastName: InquiryVisaDetails?.LastName,
        MobileNo: InquiryVisaDetails?.MobileNo,
        EmailID: InquiryVisaDetails?.EmailID,
        ContactID: InquiryVisaDetails?.ContactID,
        LeadID: InquiryVisaDetails?.LeadID,
        InquiryID: InquiryVisaDetails?.ID,
        NationalityID: InquiryVisaDetails?.NationalityID,
        Duration: InquiryVisaDetails?.Duration,
        VisaCountryID: InquiryVisaDetails?.CountryID,
        VisaCategoryID: InquiryVisaDetails?.VisaCategoryID,
        EntryTypeID: InquiryVisaDetails?.EntryTypeID,
        TravelDate: InquiryVisaDetails?.DateofTravel
          ? moment(InquiryVisaDetails?.DateofTravel, "YYYY-MM-DD").toDate()
          : "",

        TotalAdult: InquiryVisaDetails?.Adult,
        TotalCWB: InquiryVisaDetails?.Child,
        TotalCNB: InquiryVisaDetails?.Infant,
      });
    }
    return () => {
      dispatch(clearInquiryDetails());
    };
  }, [InquiryVisaDetails]);

  useEffect(() => {
    if (LeadDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: LeadDetails?.Initial,
        FirstName: LeadDetails?.FirstName,
        LastName: LeadDetails?.LastName,
        MobileNo: LeadDetails?.MobileNo,
        EmailID: LeadDetails?.EmailID,
        LeadSourceID: LeadDetails?.LeadSourceID,
        ContactID: LeadDetails?.ContactID,
        LeadID: LeadDetails?.ID,
      });
    }
    return () => {
      dispatch(clearLeadDetails());
    };
  }, [LeadDetails]);

  useEffect(() => {
    if (ContactDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: ContactDetails?.Initial,
        FirstName: ContactDetails?.FirstName,
        LastName: ContactDetails?.LastName,
        MobileNo: ContactDetails?.MobileNo,
        EmailID: ContactDetails?.EmailID,
        LeadSourceID: ContactDetails?.LeadSourceID,
        ContactID: ContactDetails?.ID,
      });
    }
    return () => {
      dispatch(clearContactDetails());
    };
  }, [ContactDetails]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      ...VisaQuotationDetail,
    });
  }, [VisaQuotationDetail]);

  useEffect(() => {
    if (!VisaQuotationID) {
      setInitialValues({
        ...initialValues,
        TermsAndCondition: AdminSettingDetails.VisaTermsAndCondition,
      });
    }
  }, [AdminSettingDetails]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  useEffect(() => {
    dispatch(getAllActiveNationalities());
    dispatch(getAllActiveVisaCountries());
    dispatch(getAllActiveVisaCategories());
    dispatch(getAllActiveVisaProcessingOptions());
    dispatch(getAllActiveTravelPurposes());
    dispatch(getAllActiveEmploymentStatus());
    dispatch(getAllActiveSponsorshipType());
    dispatch(getAllActiveAdditionalServices());
    dispatch(getAllActiveDocument());
    dispatch(getAllActiveCompanies());
    dispatch(getAllActiveEntryTypes());

    if (!VisaQuotationID) {
      dispatch(getAdminSettings());
      if (CompanyList?.length > 0) {
        const defaultCompany = CompanyList.find(
          (company) => company?.IsDefault,
        );
        if (defaultCompany) {
          setInitialValues((prev: any) => ({
            ...prev,
            CompanyID: defaultCompany?.ID,
          }));
        }
      }
    }

    if (VisaQuotationID) {
      dispatch(getVisaQuotationByID({ ID: +VisaQuotationID }));
    } else if (InquiryID) {
      dispatch(getVisaInquiryByID(InquiryID));
    } else if (LeadID) {
      dispatch(getLeadByID(LeadID));
    } else if (ContactID) {
      dispatch(getContactByID(ContactID));
    }

    return () => {
      dispatch(clearVisaQuotationInformation());
      dispatch(clearInquiryDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    // return;
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!VisaQuotationID && !InquiryID && !LeadID && !ContactID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload),
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    try {
      if (VisaQuotationID) {
        const editPayload = {
          ID: VisaQuotationID ? +VisaQuotationID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          ExpiryDate: values?.ExpiryDate
            ? moment(values?.ExpiryDate)?.format("YYYY-MM-DD")
            : "",
          TermsAndCondition: values?.TermsAndCondition
            ? values?.TermsAndCondition
            : "",
          NationalityID: values?.NationalityID ? +values?.NationalityID : null,
          DOB: values?.DOB ? moment(values?.DOB).format("YYYY-MM-DD") : "",
          PassportNumber: values?.PassportNumber ? values?.PassportNumber : "",
          PassportExpiryDate: values?.PassportExpiryDate
            ? moment(values?.PassportExpiryDate).format("YYYY-MM-DD")
            : "",
          MaritalStatus: values?.MaritalStatus ? values?.MaritalStatus : "",
          CurrentAddress: values?.CurrentAddress ? values?.CurrentAddress : "",
          VisaCountryID: values?.VisaCountryID ? +values?.VisaCountryID : null,
          VisaCategoryID: values?.VisaCategoryID
            ? +values?.VisaCategoryID
            : null,
          TravelDate: values?.TravelDate
            ? moment(values?.TravelDate).format("YYYY-MM-DD")
            : "",
          Duration: values?.Duration ? +values?.Duration : null,
          TravelPurposeID: values?.TravelPurposeID
            ? +values?.TravelPurposeID
            : null,
          EntryTypeID: values?.EntryTypeID ? +values?.EntryTypeID : null,
          ProcessingOptionID: values?.ProcessingOptionID
            ? +values?.ProcessingOptionID
            : null,
          AdditionalServicesID: values?.AdditionalServicesID
            ? values?.AdditionalServicesID?.join(", ")
            : "",
          DocumentsID: values?.DocumentsID
            ? values?.DocumentsID?.join(", ")
            : "",
          EmploymentStatusID: values?.EmploymentStatusID
            ? +values?.EmploymentStatusID
            : null,
          Income: values?.Income ? +values?.Income : null,
          CompanyName: values?.CompanyName ? values?.CompanyName : "",
          Designation: values?.Designation ? values?.Designation : "",
          BankBalance: values?.BankBalance ? +values?.BankBalance : null,
          SponsorshipID: values?.SponsorshipID ? +values?.SponsorshipID : null,
          AdditionalInfo: values?.AdditionalInfo ? values?.AdditionalInfo : "",
        };
        const response = await dispatch(updateVisaQuotation(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/quotation");
          dispatch(setQuotationType("visa"));
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          InquiryID: values?.InquiryID ? +values?.InquiryID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          ExpiryDate: values?.ExpiryDate
            ? moment(values?.ExpiryDate)?.format("YYYY-MM-DD")
            : "",
          TermsAndCondition: values?.TermsAndCondition
            ? values?.TermsAndCondition
            : "",
          NationalityID: values?.NationalityID ? +values?.NationalityID : null,
          DOB: values?.DOB ? moment(values?.DOB).format("YYYY-MM-DD") : "",
          PassportNumber: values?.PassportNumber ? values?.PassportNumber : "",
          PassportExpiryDate: values?.PassportExpiryDate
            ? moment(values?.PassportExpiryDate).format("YYYY-MM-DD")
            : "",
          MaritalStatus: values?.MaritalStatus ? values?.MaritalStatus : "",
          CurrentAddress: values?.CurrentAddress ? values?.CurrentAddress : "",
          VisaCountryID: values?.VisaCountryID ? +values?.VisaCountryID : null,
          VisaCategoryID: values?.VisaCategoryID
            ? +values?.VisaCategoryID
            : null,
          TravelDate: values?.TravelDate
            ? moment(values?.TravelDate).format("YYYY-MM-DD")
            : "",
          Duration: values?.Duration ? +values?.Duration : null,
          TravelPurposeID: values?.TravelPurposeID
            ? +values?.TravelPurposeID
            : null,
          EntryTypeID: values?.EntryTypeID ? +values?.EntryTypeID : null,
          ProcessingOptionID: values?.ProcessingOptionID
            ? +values?.ProcessingOptionID
            : null,
          AdditionalServicesID: values?.AdditionalServicesID
            ? values?.AdditionalServicesID?.join(", ")
            : "",
          DocumentsID: values?.DocumentsID
            ? values?.DocumentsID?.join(", ")
            : "",
          EmploymentStatusID: values?.EmploymentStatusID
            ? +values?.EmploymentStatusID
            : null,
          Income: values?.Income ? +values?.Income : null,
          CompanyName: values?.CompanyName ? values?.CompanyName : "",
          Designation: values?.Designation ? values?.Designation : "",
          BankBalance: values?.BankBalance ? +values?.BankBalance : null,
          SponsorshipID: values?.SponsorshipID ? +values?.SponsorshipID : null,
          AdditionalInfo: values?.AdditionalInfo ? values?.AdditionalInfo : "",
        };
        const response = await dispatch(createVisaQuotation(insertPayload));
        if (
          response?.meta?.requestStatus === "fulfilled" &&
          response.payload.Data?.ID
        ) {
          navigate("/quotation");
          dispatch(setQuotationType("visa"));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {(loading || contactLoading || leadLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 10 }}>
              <Typography.h4 className="m-0 typography-head">
                {"Visa Quotation Details"}
              </Typography.h4>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem>
                  <Field
                    wrapperClassName="m-0"
                    id={"CompanyID"}
                    name={"CompanyID"}
                    label={"Company"}
                    placeholder="Company"
                    astrike={true}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    options={CompanyList?.map((company: ICompany) => {
                      return {
                        value: company?.ID,
                        label: company?.CompanyName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="m-0"
                    validator={requiredValidator}
                    astrike={true}
                    name={`ExpiryDate`}
                    label="Expiry Date"
                    pastDate={false}
                    format="dd/MM/yyyy"
                    minDate={moment().toDate()}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                {/* <GridLayoutItem colSpan={3}></GridLayoutItem> */}

                {/* {VisaQuotationID || InquiryID || LeadID || ContactID ? (
                  <GridLayoutItem style={{ width: "100%" }} colSpan={3}>
                    <table className="w-100">
                      <tr>
                        <th>Name</th>
                        <td>:</td>
                        <td>
                          {initialValues?.Initial} {initialValues?.FirstName}{" "}
                          {initialValues?.LastName}
                        </td>
                      </tr>
                      <tr>
                        <th>Mobile No.</th>
                        <td>:</td>
                        <td>{initialValues?.MobileNo}</td>
                        <th>Email ID</th>
                        <td>:</td>
                        <td>{initialValues?.EmailID}</td>
                      </tr>
                    </table>
                    <hr className="mb-1" />
                  </GridLayoutItem>
                ) : (
                  <>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 1,
                        }}
                        id={"Initial"}
                        name={"Initial"}
                        label={"Initial"}
                        placeholder="i.e. Mr."
                        component={FormSelectionField}
                        options={NAMEPREFIX?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        name="FirstName"
                        label="First Name"
                        placeholder="i.e.John"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="LastName"
                        label="Last Name"
                        placeholder="i.e. Smith"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EmailID"
                        label="Email ID"
                        astrike={true}
                        placeholder="i.e. example@gmail.com"
                        component={FormTextField}
                        validator={emailValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-1">
                      <Field
                        name="MobileNo"
                        label="Mobile No."
                        type="text"
                        maxLength={16}
                        onKeyPress={(e: any) => {
                          const allowedChars = /^[0-9+]$/;
                          if (!allowedChars.test(e?.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="i.e. 9999999999"
                        component={FormTextField}
                        astrike={true}
                        validator={MobileNoIntValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"LeadSourceID"}
                        name={"LeadSourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3}>
                      <hr className="mb-1" />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem colSpan={3}>
                  <div
                    style={{
                      background: "#edeaea",
                      borderRadius: 10,
                      padding: "1px 10px 15px",
                      fontWeight: 600,
                    }}
                  >
                    <Field
                      label={"Select Scope"}
                      id={"flightquotetype"}
                      name={"flightquotetype"}
                      component={FormRadioGroup}
                      layout="horizontal"
                      options={FLIGHTQUOTETYPE}
                      validator={requiredValidator}
                      wrapperClassName="d-flex align-items-center gap-4"
                      // astrike={true}
                    />
                  </div>
                </GridLayoutItem> */}
              </GridLayout>
              {/* <div className="w-100 d-flex gap-3 align-items-streach">
                <ShadowCard
                  style={{
                    width: "50%",
                    boxShadow: "none",
                    backgroundColor: "#f8f9fa",
                  }}
                > */}
              <Typography.h5 className="m-0">Client Information</Typography.h5>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                {/* <GridLayoutItem>
                  <Field
                    name={`FullName`}
                    label="Full Name"
                    placeholder="John Doe"
                    component={FormTextField}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 1,
                      minWidth: 110,
                    }}
                    id={"Initial"}
                    name={"Initial"}
                    label={"Initial"}
                    placeholder="i.e. Mr."
                    component={FormSelectionField}
                    options={NAMEPREFIX?.map((initial: any) => {
                      return {
                        value: initial?.value,
                        label: initial?.label,
                      };
                    })}
                  />
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 2,
                    }}
                    name="FirstName"
                    label="First Name"
                    placeholder="i.e.John"
                    maxLength="100"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 2,
                    }}
                    name="LastName"
                    label="Last Name"
                    placeholder="i.e. Smith"
                    maxLength="100"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    // wrapperStyle={{
                    //   width: "100%",
                    //   flex: 2,
                    // }}
                    name="MobileNo"
                    label="Phone Number"
                    // type="number"
                    // max={16}
                    type="text"
                    maxLength={16}
                    onKeyPress={(e: any) => {
                      const allowedChars = /^[0-9+]$/;
                      if (!allowedChars.test(e?.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="i.e. 9999999999"
                    component={FormTextField}
                    astrike={true}
                    validator={MobileNoIntValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="EmailID"
                    label="Email Address"
                    astrike={true}
                    placeholder="i.e. example@gmail.com"
                    component={FormTextField}
                    validator={emailValidator}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                </GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    name={"DOB"}
                    label="Date Of Birth"
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                    maxDate={moment().toDate()}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`NationalityID`}
                    label="Nationality"
                    placeholder="Nationality"
                    component={FormSelectionField}
                    options={NationalityList?.map(
                      (nationality: INationality) => {
                        return {
                          value: nationality?.ID,
                          label: nationality?.Nationality,
                        };
                      },
                    )}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`PassportNumber`}
                    label="Passport No"
                    placeholder="Passport No."
                    component={FormTextField}
                    astrike={true}
                    validator={passportValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={"PassportExpiryDate"}
                    label="Passport Expiry Date"
                    pastDate={false}
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                    astrike={true}
                    validator={requiredValidator}
                    minDate={moment().toDate()}
                    onChange={(e) => {
                      if (e?.value) {
                        const selectedDate = moment(e.value);
                        const sixMonthsFromNow = moment().add(6, "months");

                        if (selectedDate.isBefore(sixMonthsFromNow)) {
                          ErrorToast(
                            "Passport is expiring soon, please renew it as soon as possible.",
                          );
                        }
                      }
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"MaritalStatus"}
                    name={"MaritalStatus"}
                    label={"Marital Status"}
                    placeholder="i.e. Married"
                    component={FormSelectionField}
                    options={MARITALSTATUS?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name={`CurrentAddress`}
                    label="Current Address"
                    component={FormTextField}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <Typography.h5 className="m-0">
                Destination & Visa Type
              </Typography.h5>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="VisaCountryID"
                    component={CardRadioGroup}
                    label="Select Destination Country"
                    // options={countryOptions}
                    options={VisaCountryList?.map((country: IVisaCountry) => {
                      return {
                        value: country?.ID,
                        label: country?.VisaCountry,
                        code: country?.CurrencyCode,
                        visaTypes: country?.VisaTypeAvailable,
                      };
                    })}
                    onChange={() => {
                      formRenderProps.onChange("VisaCategoryID", {
                        value: null,
                      });
                      formRenderProps.onChange("AdditionalServicesID", {
                        value: [],
                      });
                      formRenderProps.onChange("DocumentsID", { value: [] });
                    }}
                    cardConfig={{
                      layout: "country",
                      showCode: true,
                      codePosition: "left",
                    }}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                {formRenderProps.valueGetter("VisaCountryID") && (
                  <GridLayoutItem colSpan={2} className="mt-3">
                    <Field
                      name="VisaCategoryID"
                      component={CardRadioGroup}
                      label="Select Visa Type"
                      options={VisaCategoryList?.filter(
                        (visacategory: IVisaCategory) =>
                          visacategory?.VisaCountryID ===
                          +formRenderProps.valueGetter("VisaCountryID"),
                      )?.map((visacategory: IVisaCategory) => {
                        return {
                          value: visacategory?.ID,
                          label: visacategory?.VisaCategory,
                          visaCode: "",
                          processing: visacategory?.ProcessingTime,
                          price: visacategory?.VisaCost,
                        };
                      })}
                      cardConfig={{
                        layout: "visa",
                        showPrice: true,
                        pricePrefix: "₹",
                        showSubtitle: true,
                        showDescription: false,
                      }}
                    />
                  </GridLayoutItem>
                )}
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="w-100"
                    name={"TravelDate"}
                    label="Intended Travel Date"
                    pastDate={false}
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                    astrike={true}
                    validator={requiredValidator}
                  />
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name={`Duration`}
                    label="Duration (In Days)"
                    placeholder="0"
                    min={0}
                    max={999}
                    format="n0"
                    component={FormNumericTextField}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="w-100"
                    id={"TravelPurposeID"}
                    name={"TravelPurposeID"}
                    label={"Purpose Of Travel"}
                    placeholder="i.e. Tourism"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={TravelPurposeList?.map(
                      (travelpurpose: ITravelPurpose) => {
                        return {
                          value: travelpurpose?.ID,
                          label: travelpurpose?.TravelPurpose,
                        };
                      },
                    )}
                  />
                  <Field
                    wrapperClassName="w-100"
                    id={"EntryTypeID"}
                    name={"EntryTypeID"}
                    label={"Entry Type"}
                    placeholder="i.e. Single Entry"
                    component={FormSelectionField}
                    options={EntryTypeList?.map((entryType: IEntryType) => {
                      return {
                        value: entryType?.ID,
                        label: entryType?.EntryType,
                      };
                    })}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="ProcessingOptionID"
                    component={CardRadioGroup}
                    label="Select Processing Type"
                    options={VisaProcessingOptionList?.filter(
                      (visacountry: IVisaProcessingOption) =>
                        visacountry?.VisaCountryID ===
                        +formRenderProps.valueGetter("VisaCountryID"),
                    )?.map((visacategory: IVisaProcessingOption) => {
                      return {
                        value: visacategory?.ID,
                        label: visacategory?.Type,
                        description: visacategory?.Description,
                        price: visacategory?.Price,
                        badge: visacategory?.Duration,
                      };
                    })}
                    cardConfig={{
                      layout: "processing",
                      showBadge: true,
                      badgePosition: "top-right",
                      showPrice: true,
                      pricePrefix: "₹",
                      showDescription: true,
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="AdditionalServicesID"
                    component={CardCheckboxGroup}
                    label="Additional Services"
                    options={AdditionalServiceList?.filter(
                      (services: IAdditionalService) =>
                        services?.VisaCountryID ===
                        +formRenderProps.valueGetter("VisaCountryID"),
                    )?.map((services: IAdditionalService) => {
                      return {
                        value: services?.ID,
                        label: services?.ServiceName,
                        ServiceDescription: services?.ServiceDescription,
                        Price: services?.Price,
                      };
                    })}
                    cardConfig={{
                      layout: "country",
                      showCode: true,
                      codePosition: "left",
                    }}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <GridLayout
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "100%" }]}
              >
                <GridLayoutItem>
                  <Typography.h5 className="m-0">
                    Required Documents
                  </Typography.h5>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="DocumentsID"
                    component={CardCheckboxGroup}
                    label=""
                    options={VisaDocumentList?.map((doc: any) => {
                      return {
                        value: doc?.DocumentID,
                        label: doc?.DocumentName,
                      };
                    })}
                    cardConfig={{
                      layout: "document",
                    }}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <Typography.h5 className="m-0">
                Financial Information
              </Typography.h5>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem>
                  <Field
                    id={"EmploymentStatusID"}
                    name={"EmploymentStatusID"}
                    label={"Employment Status"}
                    placeholder="i.e. Employeed"
                    component={FormSelectionField}
                    options={EmploymentStatusList?.map(
                      (status: IEmploymentStatus) => {
                        return {
                          value: status?.ID,
                          label: status?.Title,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field"
                    name={`Income`}
                    label="Monthly Income (₹)"
                    placeholder="0"
                    min={0}
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`CompanyName`}
                    label="Company / Organization Name"
                    placeholder="Company / Organization Name"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`Designation`}
                    label="Designation / Position"
                    placeholder="Designation / Position"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field"
                    name={`BankBalance`}
                    label="Current Bank Balance (₹)"
                    placeholder="0"
                    min={0}
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"SponsorshipID"}
                    name={"SponsorshipID"}
                    label={"Sponsorship Type"}
                    placeholder="i.e. Self Sponsored"
                    component={FormSelectionField}
                    options={SponsorshipTypeList?.map(
                      (status: ISponsorshipType) => {
                        return {
                          value: status?.ID,
                          label: status?.Title,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name={`AdditionalInfo`}
                    label="Additional Finacial Info."
                    placeholder="Additional Finacial Info."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            {/* <ShadowCard
              style={{
                width: "100%",
                boxShadow: "none",
                backgroundColor: "#f8f9fa",
                marginTop: 16,
              }}
            >
              <Typography.h5 className="m-0">Booking Details</Typography.h5>
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="PPrate"
                    label="Room Rate (Per Night)"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="ExtraAdult"
                    label="Extra Adult Rate (Per Night)"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalRoomCost"
                    label="Total Room Cost"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TaxesAndFees"
                    label="Taxes & Fees"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="ServiceCharges"
                    label="Service Charges"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="Markup"
                    label="Markup (%)"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="GSTAmount"
                    label="GST (18%)"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalAmount"
                    label="Total Amount"
                    placeholder="0"
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard> */}
            <ShadowCard style={{ padding: 10, marginTop: 16 }}>
              <Typography.h5 className="m-0">Terms & Condition</Typography.h5>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="TermsAndCondition"
                    label="Terms & Condition"
                    placeholder="Terms & Condition"
                    component={FormRichTextField}
                    wrapperStyle={{
                      width: "100%",
                    }}
                    style={{
                      height: 150,
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={2}
                  style={{
                    textAlign: "end",
                    marginTop: 16,
                    width: "100%",
                  }}
                >
                  <ButtonWithLoading
                    label={VisaQuotationID ? "Update" : "Save"}
                    type="submit"
                    disabled={
                      !formRenderProps.allowSubmit || loading || contactLoading
                    }
                    loading={loading || contactLoading}
                  />
                  <RippleButton
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <VisaCountryChangeWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateVisaQuotation;
